/**
 * Генерирует криптостойкий пароль для регистрации (мин. 8 символов, буквы, цифры, спецсимволы).
 */
export function generateSecurePassword(length = 8): string {
  const lowers = 'abcdefghjkmnpqrstuvwxyz';
  const uppers = 'ABCDEFGHJKMNPQRSTUVWXYZ';
  const digits = '23456789';
  const symbols = '!@#$%&*';
  const all = lowers + uppers + digits + symbols;

  const pick = (chars: string) =>
    chars[crypto.getRandomValues(new Uint32Array(1))[0] % chars.length];

  const required = [pick(lowers), pick(uppers), pick(digits), pick(symbols)];
  const rest = Array.from({ length: Math.max(length, 8) - required.length }, () => pick(all));
  const password = [...required, ...rest];

  for (let i = password.length - 1; i > 0; i--) {
    const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join('');
}
